<div class="row">
    <div class="col-12">
      <div class="content-header">Notification  Form</div>
    </div>
  </div>
  <!-- Basic Inputs start -->
  <section id="basic-input">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- <div class="card-header">
            <h4 class="card-title">Basic</h4>
          </div> -->
          <div class="card-content">
            <div class="card-body">
              <div class="row">
                <div class="col-md">
                  <form [formGroup]="notificationForm">
                    <fieldset class="form-group">
                      <ng-select
                        [items]="usersList"
                        bindLabel="name"
                        bindValue="_id"
                        [closeOnSelect]="false"
                        placeholder="Select User"
                        [(ngModel)]="selectedValue"
                        [ngModelOptions]="{ standalone: true }"
                        (change)="getUserId($event)"
                      >
                      </ng-select>
                    </fieldset>
                    <fieldset class="form-group">
                        <label for="title">title</label>
                        <input
                          type="text"
                          formControlName="title"
                          class="form-control"
                          id="title"
                          placeholder="Enter title"
                          [ngClass]="{
                            'is-invalid': notificationForm && rf.title.invalid,
                            'is-valid': notificationForm && !rf.title.invalid
                          }"
                          required
                          #title
                        />
                        <div
                          *ngIf="rf.title.touched && rf.title.errors?.required"
                          class="help-block mt-1 text-danger"
                        >
                          <i class="ft-alert-circle align-middle"></i> title is
                          required
                        </div>  
                      </fieldset>
                      <fieldset class="form-group">
                        <label for="description">description</label>
                        <textarea formControlName="description" id="hidden-label-form-6" rows="5" class="form-control "
                         name="comment2" placeholder="Enter description"  [ngClass]="{ 'is-invalid':
                         notificationForm && rf.description.invalid, 'is-valid':
                         notificationForm && !rf.description.invalid }"
                         required #description></textarea>
                         <div *ngIf="rf.description.touched && (rf.description.invalid ||
                            rf.description.errors?.required)"
                            class="help-block mt-1 text-danger"> <i class="ft-alert-circle
                                align-middle"></i> description is required
                        </div>
                    </fieldset>
                    <fieldset class="form-group">
                        <label for="joiningLink">joiningLink</label>
                        <input
                          type="text"
                          formControlName="joiningLink"
                          class="form-control"
                          id="joiningLink"
                          placeholder="Enter joiningLink"
                          [ngClass]="{
                            'is-invalid': notificationForm && rf.joiningLink.invalid,
                            'is-valid': notificationForm && !rf.joiningLink.invalid
                          }"
                          required
                        />
                        <div
                          *ngIf="rf.joiningLink.touched && rf.joiningLink.errors?.required"
                          class="help-block mt-1 text-danger"
                        >
                          <i class="ft-alert-circle align-middle"></i> joiningLink is
                          required
                        </div>
                      </fieldset>
                      <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2">
                        <button type="submit" class="btn btn-primary mb-2 mb-sm-0 mr-sm-2" (click)="submit()">Submit</button>
                        <button type="reset" class="btn btn-secondary" (click)="back()">Cancel</button>
                      </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
